/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import '../../css/custom-responsive.css';
import '../../css/custom.css';
import { ProtocolInterface } from './marketplaceBody';

interface networkcard extends ProtocolInterface {
  num: number,
  type: 'dedicated' | 'staking'
}
const CardNetworkSelection = ({
  name, subscription_link, enabled, description, num, type,
}: networkcard) => {
  const setImage = (val: string) => {
    if (val.includes(' ')) {
      // eslint-disable-next-line prefer-destructuring, no-param-reassign
      val = val.replace(/\s/g, '');
    }
    switch (val.toLowerCase()) {
      case 'corda': return 'images/protocols/logos/corda_logo.svg';
      case 'r3': return 'images/protocols/logos/corda_logo.svg';
      case 'ethereum': return 'images/protocols/logos/ethereum_logo.svg';
      case 'credit': return 'images/protocols/logos/credits.png';
      case 'fabric': return 'images/protocols/logos/Hyperledger-Fabric_logo.svg';
      case 'hyperledgerbesu': return './images/protocols/logos/besu-icon.svg';
      case 'sawtooth': return 'images/protocols/logos/sawtooth_logo.svg';
      case 'fluree': return 'images/protocols/logos/fluree_logo.svg';
      case 'phaeton': return 'images/protocols/logos/phaeton_logo.svg';
      case 'polygon': return 'images/protocols/logos/Polygonpos_logo.svg';
      case 'binance': return 'images/protocols/logos/binance_logo.svg';
      case 'tron': return 'images/protocols/logos/tron_logo.svg';
      case 'avalanche': return 'images/protocols/logos/avalanche_logo.svg';
      case 'axia': return 'images/protocols/logos/axia_logo.svg';
      case 'fantom': return 'images/protocols/logos/Fantom_logo.svg';
      case 'dcomm': return 'images/protocols/logos/dcommdark_logo.svg';
      case 'polkadot': return 'images/protocols/logos/Polkadot_logo.svg';
      case 'okc': return 'images/protocols/logos/okc_logo.svg';
      case 'aptos': return 'images/protocols/logos/Aptos_logo.svg';
      case 'coreum': return 'images/protocols/logos/Coreum_logo.svg';
      case 'polygon-edge': return 'images/protocols/logos/Polygon-Edge_logo.svg';
      case 'shardeum': return 'images/protocols/logos/Shardeum_logo.svg';
      case 'energy-web': return 'images/protocols/logos/Energy_Web_Logo.svg';
      case 'polygoncdkchain': return 'images/protocols/logos/Polygon_cdk.svg';
      case 'parachains': return 'images/protocols/logos/parachains_logo.svg';
      case 'cordaenterprise': return 'images/protocols/logos/corda_logo.svg';
      case 'avalanche-subnets': return 'images/protocols/logos/avalanche_logo.svg';
      case 'provenanceblockchain': return 'images/protocols/logos/provenance_blockchain_logo.svg';
      case 'bahamut': return 'images/protocols/logos/fastex_logo.svg';
      case 'zksyncera': return 'images/protocols/logos/zksyncera_logo.svg';
      case 'opstack': return 'images/protocols/logos/opstack_logo.svg';
      case 'arbitrumorbit': return 'images/protocols/logos/arbitrum_orbit_logo.svg';
      case 'shido': return 'images/protocols/logos/shido_logo.svg';
      case 'beaml1': return 'images/protocols/logos/beam_logo.svg';
      case 'l1': return 'images/protocols/logos/beam_logo.svg';
      case 'beam': return 'images/protocols/logos/beam_logo.svg';
      default: return '';
    }
  };
  const showLess = (des: string, id :string, sid1:string, sid2:string) => {
    const ptag:HTMLElement|null = document.getElementById(id);
    const spanTag1:HTMLElement|null = document.getElementById(sid1);
    const spanTag2:HTMLElement|null = document.getElementById(sid2);
    if (spanTag1 && spanTag2 && ptag) {
      ptag.innerHTML = `${des.substr(0, Math.min(120, des.length))}   ...`;
      ptag.style.height = '95px';
      spanTag1.style.display = 'block';
      spanTag2.style.display = 'none';
    }
  };
  const showMore = (des: string, id :string, sid1:string, sid2:string) => {
    const ptag:HTMLElement|null = document.getElementById(id);
    const spanTag1:HTMLElement|null = document.getElementById(sid1);
    const spanTag2:HTMLElement|null = document.getElementById(sid2);

    if (ptag && spanTag1 && spanTag2) {
      ptag.innerHTML = des;
      ptag.style.height = '140px';
      spanTag1.style.display = 'none';
      spanTag2.style.display = 'block';
    }
  };
  const setOpacity = (val: boolean):string => {
    if (!val) return '.4';
    return '1';
  };
  return (
    <div style={{ display: name.toLowerCase() === 'phaeton' ? 'none' : 'block' }} className="col-xl-4 effectCard cursor mt-4 col-lg-4 col-md-12 col-sm-12">

      <div className="card">
      <a href={subscription_link || '#'} style={{ textDecoration: 'none' }}>
        <div className="card-body text-center mt-2 mb-2">
          <img src={`${type === 'dedicated' ? './' : '../'}${setImage(name)}`} alt="" style={{ opacity: setOpacity(enabled) }} height={32} />
        </div>
        <div className="row mt-4 mb-4">
        <div className="col-xl-8 col-7 col-md-4" />
          <span className="col-3 badge text-center">Do it yourself</span>
        </div>
        <div>
        <p
          className="text-muted"
          id={`desTag${num}`}
          style={{
            height: '95px', overflowY: 'hidden', textOverflow: 'ellipsis', margin: '0px 15px',
          }}
        >
          {`${description.substr(0, Math.min(120, description.length))}   ...` }
        </p>

        </div>

      </a>
      <div
            className="py-1"
            id={`ss${num}`}
            style={{
              textAlign: 'right', color: '#5B80F0 ', marginTop: '-3%', marginRight: '6px',
            }}
            onClick={() => { showMore(description, `desTag${num}`, `ss${num}`, `s${num}`); }}
      >
            &nbsp;
             Read More
      </div>

        <div
          className="py-2"
          id={`s${num}`}
          style={{
            textAlign: 'right', color: '#5B80F0 ', display: 'none', marginRight: '12px',
          }}
          onClick={() => { showLess(description, `desTag${num}`, `ss${num}`, `s${num}`); }}
        >
            &nbsp;
             Read Less
        </div>

        <div className="card-footer mt-1">
        <a href={subscription_link || '#'} style={{ textDecoration: 'none' }}>
          <div className="d-flex mt-1">
            <div className="col-6">
              <p className="mb-1 text-muted">{name}</p>
            </div>
            <div className="col-6 d-flex justify-content-end cursor">
              <div className="form-check" />
            </div>
          </div>
        </a>
        </div>

      </div>

    </div>

  );
};
export default CardNetworkSelection;
